export default [
  { id: 'ChecklistMaintenanceDetail', label: 'Checklist Maintenance', parent: '' },
];
